import { render, staticRenderFns } from "./add_device.vue?vue&type=template&id=70b23a9b&scoped=true&"
import script from "./add_device.vue?vue&type=script&lang=js&"
export * from "./add_device.vue?vue&type=script&lang=js&"
import style0 from "./add_device.vue?vue&type=style&index=0&id=70b23a9b&lang=scss&scoped=true&"
import style1 from "./add_device.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b23a9b",
  null
  
)

export default component.exports